// extracted by mini-css-extract-plugin
module.exports = {"default_card":"DefaultBio_default_card__imVxE","default_card__bioText":"DefaultBio_default_card__bioText__kIQ35","default_card__button":"DefaultBio_default_card__button__Gkka6"};